import * as React from 'react';
import CycleViewModel from 'view-models/CycleViewModel';

const columns = (handleImport: (id?: number) => void) => {
  const data = [
    {
      name: 'Titre',
      selector: 'title',
      sortable: true,
    },
    {
      name: 'Année',
      selector: 'year',
      sortable: true,
    },

    {
      center: true,
      name: 'Importer',
      maxWidth: '8vw',
      cell: (row: CycleViewModel) => (
        <button
          type="button"
          className="btn btn-block btn-primary btn-icon d-flex 
              align-items-center justify-content-center"
          onClick={(): void => handleImport(row.id)}
        >
          <i className="fa fa-edit" />
        </button>
      ),
    },
  ];
  return data;
};

export default columns;
